export default "__VITE_ASSET__CT9opWmO__"